import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")

  return (_openBlock(), _createBlock(_component_el_select_v2, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
    class: _normalizeClass(["multiselect", {small: $props.small, invalid: !$options.valid}]),
    "popper-class": "multiselect-popper",
    options: $options.options,
    multiple: "",
    placeholder: $props.placeholder,
    teleported: true
  }, null, 8 /* PROPS */, ["modelValue", "class", "options", "placeholder"]))
}